import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"meat-pepper"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2.36683 15.3995C2.36683 11.3997 7.37405 1.01773 12.6999 3.04998C15.4997 3.9999 15.9996 6.44428 15.9997 7.99966C17.5551 7.99981 19.8486 9.17351 20.9494 11.2994C23.5704 16.3615 12.3668 21.3999 8.36684 21.3999C6.15247 21.5302 5.14575 20.2899 4.95118 18.8154C3.47664 18.6208 2.23658 17.6138 2.36683 15.3995Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.9997 9.64955V7.99966M15.9997 7.99966C15.9996 6.44428 15.4997 3.9999 12.6999 3.04998C7.37405 1.01773 2.36683 11.3997 2.36683 15.3995C2.23658 17.6138 3.47664 18.6208 4.95118 18.8154C5.14575 20.2899 6.15247 21.5302 8.36684 21.3999C12.3668 21.3999 23.5704 16.3615 20.9494 11.2994C19.8486 9.17351 17.5551 7.99981 15.9997 7.99966ZM16.4498 7.30801C17.1606 6.40682 18.4252 5.39353 19.9997 4.99979","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MeatPepper = Vue.extend<IconProps>({
  name: 'MeatPepperIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'meat-pepper',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MeatPepper;
